import Dropdown from "app/components/Dropdown";
import { CheckIcon } from "app/components/Icons";
import SeverityIcon from "app/components/Icons/SeverityIcon";
import MemberProfile from "app/components/MemberProfile";
import CustomTooltip from "app/components/Tooltip";
import React, { useMemo, useState } from "react";
import { severityOptionsData } from "../../../../components/CreateBoardsComponent/data";
import { getSeverityByIds } from "../../../../helpers";
interface Props {
  value: string;
}

const Severity: React.FC<Props> = ({ value }) => {
  const selectedSeverity = useMemo(() => {
    return getSeverityByIds(value);
  }, [value]);

  const handleSelect = (value) => {
    // onUpdate(value);
  };
  const MenuItems = severityOptionsData?.map((ele) => {
    if (ele)
      return {
        label: (
          <div
            className={`flex items-center justify-between hover:bg-gray-50 rounded-md transition-colors w-full `}
            aria-label={`Profile of ${ele.id}`}
          >
            {/* Left: Icon + Text */}
            <div className="flex items-center gap-[4px]">
              <SeverityIcon size={22} color={ele.color} />
              <span className={`text-sm font-normal text-black`}>{ele.id}</span>
            </div>
            {/* Right: Tick icon only if selected */}
            {value === ele.id && <CheckIcon color="#5A8DF1" />}
          </div>
        ),
        action: () => {
          handleSelect(ele.id);
        },
      };
    else return { label: "", action: () => {} };
  });
  return (
    <Dropdown
      trigger={
        <button className="flex items-center justify-start hover:border hover:border-[#BDC0C3] p-[4px] rounded-[2px] min-w-[109px] cursor-pointer  ">
          <CustomTooltip
            text="Set severity"
            className="flex items-center "
            position="left"
          >
            <div className="flex items-center gap-2 w-full">
              <SeverityIcon size={18} color={selectedSeverity?.color} />
              <span className="text-sm font-normal text-black">
                {selectedSeverity?.id}
              </span>
            </div>
          </CustomTooltip>
        </button>
      }
      projectInfoIcon={
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between px-4 py-3 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase border-b border-gray-100 ">
            <span>severity</span>
          </div>
        </div>
      }
      menuItems={MenuItems ? MenuItems : []}
      align="center"
      className="py-2"
    />
  );
};

export default Severity;
